import {InteractiveSceneV2Config} from '@/components/player-v2/InteractiveSceneV2/types';

export enum WRBranchTimestamp2 {
  EP_1_1 = 52, // 0:52
  EP_4_1 = 598, // 9:58
  EP_4_2 = 633, // 10:33
  EP_4_3 = 699, // 11:39
  EP_5_1 = 1124.4, // 18:44
}

export enum WRBranchTimestamp {
  EP_1_1 = 52, // 0:52
  EP_4_1 = 602, // 10:02
  EP_4_2 = 637, // 10:37
  EP_4_3 = 703, // 11:43
  EP_5_1 = 1124.4, // 18:44
}

export function useInteractiveSceneV2Config({
  isCh6 = false,
}): InteractiveSceneV2Config {
  return [
    {
      start: isCh6 ? WRBranchTimestamp2.EP_4_1 : WRBranchTimestamp.EP_4_1,
      title: 'Can you bear it?',
      duration: 10,
      skippable: false,
      defaultChoice: 0,
      buttonChoices: [
        {
          text: "I've come this far.",
          after: {
            audio: {
              duration: 3,
              url: 'https://storage.googleapis.com/shibuya-white-rabbit/WhiteRabbit_C4_ThisFar.wav',
              subtitle: "I've come this far.",
            },
          },
        },
        {
          text: 'Perhaps there is another way.',
          after: {
            audio: {
              duration: 3,
              url: 'https://storage.googleapis.com/shibuya-white-rabbit/WhiteRabbit_C4_Another%20Way.wav',
              subtitle: 'Perhaps there is another way.',
            },
          },
        },
      ],
    },
    {
      start: isCh6 ? WRBranchTimestamp2.EP_4_2 : WRBranchTimestamp.EP_4_2,
      title: 'Is the struggle worth the unknown?',
      duration: 10,
      skippable: false,
      defaultChoice: 0,
      buttonChoices: [
        {
          text: "I'm sure it will pay off.",
          after: {
            audio: {
              duration: 4,
              url: 'https://storage.googleapis.com/shibuya-white-rabbit/WhiteRabbit_C4_Payoff.wav',
              subtitle: "I'm sure it will pay off.",
            },
          },
        },
        {
          text: 'Learning resides in knowing when to turn around',
          after: {
            audio: {
              duration: 4,
              url: 'https://storage.googleapis.com/shibuya-white-rabbit/WhiteRabbit_C4_LearningResides.wav',
              subtitle: 'Learning resides in knowing when to turn around',
            },
          },
        },
      ],
    },
    {
      start: isCh6 ? WRBranchTimestamp2.EP_4_3 : WRBranchTimestamp.EP_4_3,
      title: "Your truth isn't written in the voices of others...",
      duration: 12,
      skippable: false,
      defaultChoice: 0,
      buttonChoices: [
        {
          text: "It's just noise...",
          after: {
            audio: {
              duration: 3,
              url: 'https://storage.googleapis.com/shibuya-white-rabbit/WhiteRabbit_C4_Payoff.wav',
              subtitle: "It's just noise...",
            },
          },
        },
        {
          text: 'Echoes carry wisdom',
          after: {
            audio: {
              duration: 3,
              url: 'https://storage.googleapis.com/shibuya-white-rabbit/WhiteRabbit_C4_LearningResides.wav',
              subtitle: 'Echoes carry wisdom',
            },
          },
        },
      ],
    },
    {
      start: isCh6 ? WRBranchTimestamp2.EP_5_1 : WRBranchTimestamp.EP_5_1,
      title: 'Which way?',
      during: {
        video: {
          loop: true,
          url: 'https://storage.googleapis.com/shibuya-white-rabbit/ch5/C5_EDITORIAL_040_Selection_Backdrop_0422.mp4',
        },
      },
      duration: 12,
      skippable: false,
      defaultChoice: 1,
      areaChoices: [
        {
          label: {
            text: 'Ramen Shop',
            y: 100,
            x: 200,
          },
          during: {
            video: {
              url: 'https://storage.googleapis.com/shibuya-white-rabbit/ch5/C5_EDITORIAL_040_Ramen_0422.mp4',
              loop: true,
            },
          },
          after: {
            video: {
              url: 'https://storage.googleapis.com/shibuya-white-rabbit/ch5/C5_EDITORIAL_040_Kidding_0422.mp4',
              loop: false,
            },
            fn: () => {},
          },
        },
        {
          label: {
            text: 'Arcade',
            x: 100,
            y: 200,
          },
          during: {
            video: {
              url: 'https://storage.googleapis.com/shibuya-white-rabbit/ch5/C5_EDITORIAL_040_Arcade_0422.mp4',
              loop: true,
            },
          },
          after: {
            fn: () => {},
          },
        },
      ],
    },
  ];
}
